import Select from 'react-select'
import Datetime from 'react-datetime'
import { KTSVG } from '_metronic/helpers'
import { ISSUE_TYPES_OPTIONS } from 'Configuration/Paco'
import moment from 'moment'

interface Props {
  saleOrder: any[]
  filter: any
  onChangeFilter: (name: string, value: any) => void
  onClearFilter: () => void
  onSubmit: () => void
}

const Filter: React.FC<Props> = ({
  filter,
  onChangeFilter,
  onClearFilter,
  onSubmit,
  saleOrder,
}) => {
  const statusOptions = ISSUE_TYPES_OPTIONS.map(item => ({
    label: item,
    value: item,
  }))

  return (
    <div
      id='kt_maintenance_list_filter'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_maintenance_list_filter_toggle'
      data-kt-drawer-close='#kt_maintenance_list_filter_close'>
      <div className='card w-100 rounded-0'>
        <div className='card-header pe-5'>
          <div className='card-title'>
            {/* begin:: Title */}
            <div className='d-flex justify-content-center flex-column me-3'>
              <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                ค้นหา
              </span>
            </div>
            {/* end:: Title */}
          </div>

          <div className='card-toolbar'>
            {/* begin:: Close Button */}
            <button
              className='btn btn-sm btn-bg-white btn-active-light-danger text-center'
              id='kt_maintenance_list_filter_close'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr015.svg'
                className='svg-icon svg-icon-2x mx-auto'
              />
            </button>
            {/* end:: Close Button */}
          </div>
        </div>

        <div className='card-body'>
          <div
            data-kt-element='messages'
            data-kt-scroll='true'
            data-kt-scroll-activate='{default: false, lg: true}'
            data-kt-scroll-max-height='auto'
            data-kt-scroll-offset='5px'>
            <div className='row gy-5'>
              {/* <div className='col-12'>
                <div className='fs-6 mb-3'>Sale Order ID</div>

                <input type='text' className='form-control form-control-sm' placeholder='' />
              </div> */}

              {/* begin:: Division */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อหน่วยงาน</div>

                <input
                  className='form-control form-control-sm'
                  type='text'
                  value={filter.division}
                  onChange={(e: any) => onChangeFilter('division', e.target.value)}
                  placeholder='ค้นหาด้วยชื่อหน่วยงาน'
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_shipping_list_filter_close')?.click()
                    }
                  }}
                />
              </div>
              {/* end:: Division */}

              {/* begin:: Status */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>สถานะงาน</div>

                <Select
                  styles={{
                    control: (provided: any, state: any) => ({
                      ...provided,
                      borderColor: '#e1e3ea',
                    }),
                  }}
                  // @ts-ignore
                  options={statusOptions}
                  value={statusOptions.find(s => s.value === filter.jobStatus) ?? null}
                  // @ts-ignore
                  onChange={(e: any) => onChangeFilter('jobStatus', e?.value)}
                  placeholder='ค้นหาด้วยสถานะของงาน'
                />
              </div>
              {/* end:: Status */}

              {/* begin:: Start Period Date */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>วันที่เข้าไปทำ</div>

                <Datetime
                  locale='en'
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                  inputProps={{
                    placeholder: 'ค้นหาด้วยวันที่เข้าไปทำ',
                  }}
                  renderInput={props => {
                    return (
                      <input
                        {...props}
                        autoComplete='off'
                        value={
                          moment(filter.startPeriod).isValid() && filter.startPeriod !== ''
                            ? moment(filter.startPeriod).format('DD/MM/YYYY')
                            : ''
                        }
                      />
                    )
                  }}
                  closeOnClickOutside
                  value={filter.startPeriod}
                  onChange={(e: any) => onChangeFilter('startPeriod', e)}
                  className='filter-date-input w-100'
                />
              </div>
              {/* end:: Start Period Date */}
              <div className='col-12 d-flex flex-row'>
                <button
                  className='btn btn-sm btn-primary me-4 w-50 fw-bold'
                  id='kt_maintenance_list_filter_close'
                  onClick={onSubmit}>
                  ค้นหา
                </button>
                <button
                  className='btn btn-sm btn-danger w-50 fw-bold'
                  id='kt_maintenance_list_filter_close'
                  onClick={onClearFilter}>
                  ล้างค่า
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter
